/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Avatar: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7ZM12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3ZM17.0569 16.5574C17.9807 17.2503 18.5954 18.0961 18.857 19H5.14304C5.40455 18.0961 6.01929 17.2503 6.94315 16.5574C8.20174 15.6134 9.98631 15 12 15C14.0137 15 15.7983 15.6134 17.0569 16.5574ZM12 13C9.59541 13 7.37998 13.7297 5.74315 14.9574C4.10601 16.1852 3 17.9578 3 20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20C21 17.9578 19.894 16.1852 18.2569 14.9574C16.62 13.7297 14.4046 13 12 13Z'
      fill='currentColor'
    />
  </React.Fragment>
)
